<template>
  <div style="display: inline-block;width:100%;" :class="[defaultClass, isVisible ? animationClass : '']" ref="lazyElement">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    defaultClass: {
      type: String
    },
    animationClass: {
      type: String
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    this.observeIntersection()
  },
  methods: {
    observeIntersection() {
      const options = {
        root: null, // 使用默认的视口作为根元素
        rootMargin: '0px',
        threshold: 0.2 // 当元素至少有10%可见时触发
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true
            observer.unobserve(entry.target) // 动画开始后停止观察
          }
        })
      }, options)
      observer.observe(this.$refs.lazyElement)
    }
  },
  components: {}
}
</script>

<style scoped></style>
